import { ff } from '@atlassian/jira-feature-flagging';
import type {
	CommandInternal,
	DefaultFallback,
	FallbackOptions,
} from '../../../../common/types/commands/index.tsx';
import { getActiveCommandList } from '../../../../common/utils/get-active-command-list';

type GetFallbackProps = {
	defaultFallback: DefaultFallback | undefined;
	expandedCommand: CommandInternal | undefined;
	rootFallback?: FallbackOptions | undefined;
	noResults: boolean;
	fallbackOverride?: DefaultFallback | undefined;
};

export const getFallback = ({
	defaultFallback,
	rootFallback,
	expandedCommand,
	noResults,
	fallbackOverride,
}: GetFallbackProps): DefaultFallback | undefined => {
	const rootNoResultsFallback: DefaultFallback | undefined = rootFallback
		? { onNoResults: rootFallback }
		: undefined;
	if (ff('compal-issue-actions-very-high-priority_f5w5r') && fallbackOverride) {
		return {
			...rootNoResultsFallback,
			...fallbackOverride,
			...(!noResults && { onNoResults: undefined }), // remove onNoResults fallback when there are results
		};
	}
	const wasSecondaryTriggered = expandedCommand?.wasSecondaryTriggered;
	const activeCommandList = getActiveCommandList(expandedCommand, wasSecondaryTriggered);
	const commandFallback = activeCommandList?.fallback;

	if (!defaultFallback && !commandFallback && !rootNoResultsFallback) return undefined;

	return {
		...rootNoResultsFallback,
		...(expandedCommand ? defaultFallback : {}), // only override root when not on root
		...commandFallback,
		...(!noResults && { onNoResults: undefined }), // remove onNoResults fallback when there are results
	};
};
